import { createSlice } from "@reduxjs/toolkit"

export const couponSlice = createSlice({
    name: "coupon",
    initialState: {
        couponList: [],
        exportList: [],
        couponDetail: {},
        bulk:0,
        isFreshData: false,
        totalEntry: 0,
        filterTerm: '',
        discountOptions: [{ value: 1, label: "Fixed" }, { value: 2, label: "Percentage" }],
        chargeOptions: [{ value: 1, label: "AFA" }, { value: 2, label: "Merchant" }],
        days: [
                { value: "monday", label: "Monday" },
                { value: "tuesday", label: "Tuesday" },
                { value: "wednesday", label: "Wednesday" },
                { value: "thursday", label: "Thursday" },
                { value: "friday", label: "Friday" },
                { value: "saturday", label: "Saturday" },
                { value: "sunday", label: "Sunday" } 
            ]
    }, 
    reducers: {
        setCouponList: (state, action) => {
            state.couponList = action.payload
        },
        setExportList: (state, action) => {
            state.exportList = action.payload
        },
        setFilterTerm: (state, action) => {
            state.filterTerm = action.payload
        },
        setTotalEntry: (state, action) => {
            state.totalEntry = action.payload
        },
        setSingleData: (state, action) => {
            state.couponDetail = action.payload
        },
        setBulk: (state, action) => {
            state.bulk = action.payload
        }
    }
})

export const {
    setCouponList,
    setExportList,
    setFilterTerm,
    setSingleData,
    setTotalEntry,
    setFilteredList,
    setBulk
} = couponSlice.actions

export const selectCouponList = (state) => state.coupon.couponList
export const selectExportList = (state) => state.coupon.exportList
export const selectFilterTerm = (state) => state.coupon.filterTerm
export const selectTotalEntry = (state) => state.coupon.totalEntry
export const selectCouponDetail = (state) => state.coupon.couponDetail
export const selectBulk = (state) => state.coupon.bulk
export const selectDiscountOptions = (state) => state.coupon.discountOptions
export const selectChargeOptions = (state) => state.coupon.chargeOptions
export const selectDays = (state) => state.coupon.days

export default couponSlice.reducer
